module.exports = __webpack_public_path__ + "static/img/tqzl-foot.b816dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tqzl-foot.png
// module id = GqPt
// module chunks = 8